import wrapper from 'wrapper';
import events from '../../utils/events-emitter';

class Profile {
    constructor() {
        this.categoryHeaders = wrapper.selectAll('.category-header');

        // Hide headers outside of core content
        this.categoryHeaders.forEach((header) => {
            header.classList.add('hidden');
        });
        this.profileContainer = wrapper.select('.profile__section');
        this.profiles = wrapper.selectAll('.profile');
        this.activeButton = wrapper.select('.filter-buttons__button-input.active');
        this.activeCategory = this.activeButton.classList[1].replace(
            'filter-buttons__button-input--',
            '',
        );
        this.allCategory = this.activeButton.classList[1].replace(
            'filter-buttons__button-input--',
            '',
        ); // Do not update; sets 'All'
        this.countDiv = wrapper.select('.filter-buttons__count');
        this.countDiv.innerHTML = `${__(
            'filter_button_results_text',
        )} <span class="highlight">${this.profiles.length}</span>`;

        this.alphabetiseProfiles();

        events.on('filter-update', (category) => {
            this.activeCategory = category;
            this.activeButton = wrapper.select(
                '.filter-buttons__button.active',
            );
            this.handleFilterChange(category);
        });
    }

    alphabetiseProfiles() {
        const sortedProfiles = this.profiles.sort((a, b) => {
            const nameA = a.classList[2].replace('profile--', '');
            const nameB = b.classList[2].replace('profile--', '');
            // eslint-disable-next-line no-nested-ternary
            return nameA > nameB ? 1
                : nameB > nameA ? -1 : 0;
        });

        sortedProfiles.forEach((profile) => this.profileContainer.append(profile));
        this.profiles = wrapper.selectAll('.profile');
    }

    handleFilterChange() {
        let totalProfiles = 0;
        if (this.activeCategory === this.allCategory) {
            this.profiles.forEach((profile) => {
                profile.classList.remove('hidden');
                totalProfiles += 1;
            });
        }

        else {
            this.profiles.forEach((profile) => {
                if (profile.classList.contains(`profile--${this.activeCategory}`)) {
                    profile.classList.remove('hidden');
                    totalProfiles += 1;
                }
                else if (!profile.classList.contains('hidden')) profile.classList.add('hidden');
            });
        }

        this.countDiv.innerHTML = `${__(
            'filter_button_results_text',
        )} <span class="highlight">${totalProfiles}</span>`;
    }
}

export default Profile;
